import React, { useEffect, useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useDeleteVarientMutation } from "../../Services/ProductAPI"
import Switch from "react-switch";

import { useGetVarientsbyCategoryIdQuery, useUpdateVariantStatusMutation } from "../../Services/StockManagemntAPI"
function Products() {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const { productId } = useParams();
    const { data, isLoading, refetch } = useGetVarientsbyCategoryIdQuery(productId);
    const [deleteVarient] = useDeleteVarientMutation();
    const [updateVariantStatus] = useUpdateVariantStatusMutation();

    useEffect(() => {
        refetch();
    }, [refetch]);

    const filteredData = data
        ? data?.filter((item) =>
            Object.values(item).some(
                (value) =>
                    value !== null &&
                    value !== undefined &&
                    value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : [];


    // Pagination logic
    const totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
    console.log("currentItems", currentItems)
    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this varient?");
        if (!confirmDelete) return;

        try {
            await deleteVarient(id).unwrap();  // Call delete API
            alert("Variant deleted successfully!");
            refetch();  // Refresh the list after deletion
        } catch (error) {
            console.error("Error deleting brand:", error);
            alert("Failed to delete brand. Please try again.");
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {

            let formData = {
                type: "variant",
                id: id,
                status: newStatus
            }


            const response = await updateVariantStatus(formData);
            console.log(response);
            refetch();
        } catch (error) {
            console.error("Error updating category status:", error);
        }
    };

    if (isLoading) return <div class="loader"></div>;
    // if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Variant</h3>
            {/* <div className="breadcrum mb-4">
                <p>
                    <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
                    <Link to={`/list-varients`}><span>Back</span></Link>
                </p>
            </div> */}
            <div className="content-wrapper">
                <div>
                    {/* Search Input */}
                    <div className="row justify-flex-end search-box">
                        <div className="col-md-6 col-sm-12 col-lg-6 d-flex justify-end gap-10">
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </InputGroup>
                            <Link to={`/add-varients`}><button className="btn-primary w-100"><FontAwesomeIcon
                                icon={faPlus}
                                className="text-primary mx-2"
                            />Add new</button></Link>
                        </div>

                    </div>


                    {/* Table */}
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Values</th>
                                    {/* <th>Category</th> */}
                                    <th>Action</th>
                                   <th>Hide/Show</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.name}</td>
                                            {/* <td>{item.category?.category_name}</td> */}
                                            <td>
                                                {item.values?.length > 0
                                                    ? item.values.map((value, index) => (
                                                        <span key={value.id}>
                                                            {value.value}
                                                            {index !== item.values.length - 1 && ", "}
                                                        </span>
                                                    ))
                                                    : "No values"}
                                            </td>
                                            <td>
                                                <Link to={`/edit-varients/${item.id}`}>
                                                    <FontAwesomeIcon icon={faEdit} className="text-warning mx-2" style={{ cursor: "pointer" }} />
                                                </Link>
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    className="text-danger mx-2"
                                                    onClick={() => handleDelete(item.id)}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </td>
                                            <td>
                                                <Switch
                                                    onChange={() => handleStatusChange(item.id, item.filter_status === 1 ? 0 : 1)}
                                                    checked={item.filter_status === 1}
                                                    onColor="#4CAF50"
                                                    offColor="#ccc"
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                />
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </Table>
                    </div>


                    {/* Pagination */}
                    <Pagination className="d-flex justify-flex-end">
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            </div>
        </div>
    );
}

export default Products;
